export const CUSTOMER_DISCOUNT_PERCENT = 5;

export const roundMoney = (value) => {
  return Math.round(
    (Number(value) + Number.EPSILON) * 100
  ) / 100;
};

export const getProductDeal = (product) => {
  const deals =
    product?.productDeals ||
    product?.ProductDeals ||
    product?.deals ||
    product?.Deals ||
    [];

  if (!Array.isArray(deals)) {
    return null;
  }

  return (
    deals.find((deal) => {
      const isActive =
        deal?.isActive ??
        deal?.IsActive;

      return (
        isActive === true ||
        isActive === 1 ||
        isActive === "1"
      );
    }) ||
    null
  );
};
export const getDealGroupId = (
  product
) => {
  const deal =
    getProductDeal(product);

  if (!deal) {
    return null;
  }

  const dealGroupId =
    deal?.dealGroupId ??
    deal?.DealGroupId ??
    null;

  if (
    dealGroupId === null ||
    dealGroupId === undefined ||
    dealGroupId === ""
  ) {
    return null;
  }

  const normalizedDealGroupId =
    Number(dealGroupId);

  if (
    !Number.isInteger(
      normalizedDealGroupId
    ) ||
    normalizedDealGroupId <= 0
  ) {
    return null;
  }

  return normalizedDealGroupId;
};

export const getOrderItemUnitPrice = (
  item
) => {
  const product =
    item?.product ??
    item?.Product;

  const productOption =
    item?.productOption ??
    item?.ProductOption;

  const productPrice = Number(
    product?.price ??
    product?.Price ??
    0
  );

  const optionPrice = Number(
    productOption?.extraPrice ??
    productOption?.ExtraPrice ??
    0
  );

  return optionPrice > 0
    ? optionPrice
    : productPrice;
};

export const hasProductDeal = (product) => {
  const deal = getProductDeal(product);

  if (!deal) {
    return false;
  }

  const dealType = Number(
    deal.dealType ??
    deal.DealType ??
    0
  );

  return dealType !== 0;
};
export const isDealApplied = (
  deal,
  quantity
) => {
  if (!deal || quantity <= 0) {
    return false;
  }

  const dealType = Number(
    deal?.dealType ??
    deal?.DealType ??
    0
  );

  const dealQuantity = Number(
    deal?.quantity ??
    deal?.Quantity ??
    0
  );

  const dealPrice = Number(
    deal?.dealPrice ??
    deal?.DealPrice ??
    0
  );

  const discountPercent = Number(
    deal?.discountPercent ??
    deal?.DiscountPercent ??
    0
  );

  // מבצע X+1
  if (dealType === 1) {
    return (
      dealQuantity > 0 &&
      quantity >= dealQuantity + 1
    );
  }

  // מבצע X במחיר קבוע
  if (dealType === 2) {
    return (
      dealQuantity > 0 &&
      dealPrice > 0 &&
      quantity >= dealQuantity
    );
  }

  // מבצע אחוז הנחה
  if (dealType === 3) {
    return (
      discountPercent > 0 &&
      discountPercent <= 100
    );
  }

  return false;
};
export const isProductDealApplied = (
  item
) => {
  const deal =
    getProductDeal(
      item?.product
    );

  const quantity = Number(
    item?.amount || 0
  );

  return isDealApplied(
    deal,
    quantity
  );
};
export const calculateOrderItemTotal = (item) => {
  const quantity = Number(
    item?.amount || 0
  );

  const unitPrice =
    getOrderItemUnitPrice(item);

  const product = item?.product;
  const deal = getProductDeal(product);

  if (!deal) {
    return unitPrice * quantity;
  }

  const dealType = Number(
    deal.dealType ??
    deal.DealType ??
    0
  );

  const dealQuantity = Number(
    deal.quantity ??
    deal.Quantity ??
    0
  );

  const dealPrice = Number(
    deal.dealPrice ??
    deal.DealPrice ??
    0
  );

  const discountPercent = Number(
    deal.discountPercent ??
    deal.DiscountPercent ??
    0
  );

  // 1 = 2+1 / 3+1 וכדומה
  if (
    dealType === 1 &&
    dealQuantity > 0
  ) {
    const groupSize =
      dealQuantity + 1;

    const fullGroups =
      Math.floor(quantity / groupSize);

    const remaining =
      quantity % groupSize;

    const paidItems =
      fullGroups * dealQuantity +
      remaining;

    return paidItems * unitPrice;
  }

  // 2 = כמות במחיר מיוחד
  if (
    dealType === 2 &&
    dealQuantity > 0 &&
    dealPrice > 0
  ) {
    const fullGroups =
      Math.floor(
        quantity / dealQuantity
      );

    const remaining =
      quantity % dealQuantity;

    return (
      fullGroups * dealPrice +
      remaining * unitPrice
    );
  }

  // 3 = אחוז הנחה על מוצר
  if (
    dealType === 3 &&
    discountPercent > 0
  ) {
    const priceAfterDiscount =
      unitPrice *
      (1 - discountPercent / 100);

    return (
      priceAfterDiscount * quantity
    );
  }

  return unitPrice * quantity;
};
export const calculateGroupedDealTotal = (
  items,
  deal
) => {
  const unitPrices = [];

  items.forEach((item) => {
    const quantity = Number(
      item?.amount || 0
    );

    const unitPrice =
      getOrderItemUnitPrice(item);

    for (
      let index = 0;
      index < quantity;
      index += 1
    ) {
      unitPrices.push(unitPrice);
    }
  });

  const regularTotal =
    unitPrices.reduce(
      (sum, price) => sum + price,
      0
    );

  if (
    !deal ||
    unitPrices.length === 0
  ) {
    return regularTotal;
  }

  const dealType = Number(
    deal?.dealType ??
    deal?.DealType ??
    0
  );

  const dealQuantity = Number(
    deal?.quantity ??
    deal?.Quantity ??
    0
  );

  // מבצע X+1
  if (
    dealType === 1 &&
    dealQuantity > 0
  ) {
    const groupSize =
      dealQuantity + 1;

    const freeItemsCount =
      Math.floor(
        unitPrices.length /
        groupSize
      );

    /*
     * כמו בשרת:
     * המוצרים הזולים ביותר בחינם.
     */
    const sortedPrices = [
      ...unitPrices,
    ].sort(
      (first, second) =>
        first - second
    );

    const freeItemsTotal =
      sortedPrices
        .slice(0, freeItemsCount)
        .reduce(
          (sum, price) =>
            sum + price,
          0
        );

    return (
      regularTotal -
      freeItemsTotal
    );
  }

  // מבצע X במחיר מסוים
  if (dealType === 2) {
    const dealPrice = Number(
      deal?.dealPrice ??
      deal?.DealPrice ??
      0
    );

    if (
      dealQuantity <= 0 ||
      dealPrice <= 0
    ) {
      return regularTotal;
    }

    const completeGroups =
      Math.floor(
        unitPrices.length /
        dealQuantity
      );

    const amountInDeals =
      completeGroups *
      dealQuantity;

    /*
     * כמו בשרת:
     * היקרים נכנסים למבצע,
     * והזולים שנותרו משולמים רגיל.
     */
    const sortedPrices = [
      ...unitPrices,
    ].sort(
      (first, second) =>
        second - first
    );

    const remainingTotal =
      sortedPrices
        .slice(amountInDeals)
        .reduce(
          (sum, price) =>
            sum + price,
          0
        );

    return (
      completeGroups *
      dealPrice +
      remainingTotal
    );
  }

  // מבצע אחוז הנחה
  if (dealType === 3) {
    const discountPercent =
      Number(
        deal?.discountPercent ??
        deal?.DiscountPercent ??
        0
      );

    if (
      discountPercent <= 0 ||
      discountPercent > 100
    ) {
      return regularTotal;
    }

    return (
      regularTotal *
      (
        1 -
        discountPercent / 100
      )
    );
  }

  return regularTotal;
};

export const calculateOrderDiscountSummary = (
  order
) => {
  const items =
    order?.ordersProducts || [];

  const user = order?.user;

  const isEligible =   
    isUserEligibleForCustomerDiscount(
      user
    );

  let regularSubtotal = 0;
  let subtotal = 0;
  let discountableSubtotal = 0;

  /*
   * מחיר רגיל לפני כל המבצעים.
   */
  items.forEach((item) => {
    regularSubtotal +=
      getOrderItemUnitPrice(item) *
      Number(item?.amount || 0);
  });

  /*
   * מוצרים שאינם שייכים לקבוצת מבצע.
   */
  const individualItems =
    items.filter((item) => {
      const dealGroupId =
        getDealGroupId(
          item?.product
        );

      return dealGroupId === null;
    });

  individualItems.forEach((item) => {
    const unitPrice =
      getOrderItemUnitPrice(item);

    const lineTotal =
      calculateOrderItemTotal(item);

    subtotal += lineTotal;

    const deal =
      getProductDeal(
        item?.product
      );

    const quantity = Number(
      item?.amount || 0
    );

    const dealApplied =
      isDealApplied(
        deal,
        quantity
      );

    if (
      isEligible &&
      unitPrice > 1 &&
      !dealApplied
    ) {
      discountableSubtotal +=
        lineTotal;
    }
  });

  /*
   * יצירת קבוצות לפי DealGroupId.
   */
  const dealGroups =
    new Map();

  items.forEach((item) => {
    const dealGroupId =
      getDealGroupId(
        item?.product
      );

    if (dealGroupId === null) {
      return;
    }

    if (
      !dealGroups.has(
        dealGroupId
      )
    ) {
      dealGroups.set(
        dealGroupId,
        []
      );
    }

    dealGroups
      .get(dealGroupId)
      .push(item);
  });

  /*
   * חישוב כל קבוצת מבצע ביחד.
   */
  dealGroups.forEach(
    (groupItems) => {
      const firstItem =
        groupItems[0];

      const deal =
        getProductDeal(
          firstItem?.product
        );

      const totalGroupQuantity =
        groupItems.reduce(
          (sum, item) =>
            sum +
            Number(
              item?.amount || 0
            ),
          0
        );

      const groupDealApplied =
        isDealApplied(
          deal,
          totalGroupQuantity
        );

      const groupTotal =
        calculateGroupedDealTotal(
          groupItems,
          deal
        );

      subtotal += groupTotal;

      /*
       * אם המבצע הקבוצתי לא הופעל,
       * המוצרים יכולים לקבל הנחת לקוחה.
       */
      if (
        isEligible &&
        !groupDealApplied
      ) {
        groupItems.forEach(
          (item) => {
            const unitPrice =
              getOrderItemUnitPrice(
                item
              );

            if (unitPrice > 1) {
              discountableSubtotal +=
                unitPrice *
                Number(
                  item?.amount || 0
                );
            }
          }
        );
      }
    }
  );

  regularSubtotal =
    roundMoney(regularSubtotal);

  subtotal =
    roundMoney(subtotal);

  discountableSubtotal =
    roundMoney(
      discountableSubtotal
    );

  const dealDiscountAmount =
    roundMoney(
      regularSubtotal -
      subtotal
    );

  const discountAmount =
    isEligible
      ? roundMoney(
        discountableSubtotal *
        (
          CUSTOMER_DISCOUNT_PERCENT /
          100
        )
      )
      : 0;

  const finalTotal =
    roundMoney(
      subtotal -
      discountAmount
    );

  return {
    isEligible,

    // מחיר לפני מבצעים
    regularSubtotal,

    // מחיר אחרי מבצעים ולפני 5%
    subtotal,

    // הסכום שעליו מותר לתת 5%
    discountableSubtotal,

    discountPercent:
      CUSTOMER_DISCOUNT_PERCENT,

    // הנחת המבצעים
    dealDiscountAmount,

    // הנחת הלקוחה הקבועה
    discountAmount,

    // מחיר סופי ללא משלוח
    finalTotal,
  };
};

export const isUserEligibleForCustomerDiscount = (
  user
) => {
  return (
    user?.hasPermanentDiscount ===
    true ||
    user?.HasPermanentDiscount ===
    true
  );
};

export const formatILS = (value) => {
  return `₪${Number(
    value || 0
  ).toLocaleString("he-IL", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  })}`;
};